import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.ADMINISTRATOR_PERMISSIONS.SET,
  payload,
})
